module.exports = __webpack_public_path__ + "static/media/nextIcon.ac45e267.svg";